module.exports = __webpack_public_path__ + "img/ico-search-query.401a0712.png";